import React, { useContext, useEffect, useState } from "react";
import { Input, Button, Form, App, Space, Typography } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import { ActionType, API, Enum, Regex } from "../../resources/constants";
import language from "../../resources/languages/fa_IR";

// Interfaces
import { AxiosError } from "../../interfaces/axios"

// Contexts
import GlobalContext from "../../contexts/global";
import AxiosContext from "../../contexts/axios";

const { Components: { Profile }, Validation, Message: MessageLanguage } = language
const { SET_USER, SET_OPEN_DRAWER } = ActionType
const { USER_MANAGEMENT_AUTH_UPDATE_PROFILE, USER_MANAGEMENT_AUTH_PROFILE } = API
const { Message } = Enum
const { isNumber, notEnglish } = Regex

export default function Index() {

    const [form] = Form.useForm()
    const [, forceUpdate] = useState({})
    const { user, dispatch } = useContext(GlobalContext)
    const { axios } = useContext(AxiosContext)
    const { message } = App.useApp()

    useEffect(() => {
      // To disable submit button at the beginning.
      forceUpdate({});

      form.validateFields().then( response => response ).catch( error => error );
    }, []);

    const onFinish = (values: {}) => {
      axios.patch(USER_MANAGEMENT_AUTH_UPDATE_PROFILE, {...values}).then((response: {}) => {
        axios.get(USER_MANAGEMENT_AUTH_PROFILE).then((response: { data: {} }) => {
          const { data: user } = response
          dispatch({ type: SET_USER , payload: { user }})
          dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: false }})
          message.success(MessageLanguage[Message.UPDATE_PROFILE]).then(response => response)
        })
      }).catch( (error: AxiosError) => {
        const { response: { data } } = error;
        // @ts-ignore
        message.error(MessageLanguage[data.message]).then(response => response)
      })
    };

    return (
      <Form form={form} name="filter" onFinish={onFinish} initialValues={{...user, mobile: user && `0${user.mobile}`}}>
        <Form.Item
          name="firstName"
          style={{marginBottom:5}}
          rules={[
            { required: true, message: `${Profile.firstName} ${Validation.required}` },
            { min: 3, message: `${Profile.firstName} ${Validation.min} 3 ${Validation.length}` },
            { max: 30, message: `${Profile.firstName} ${Validation.max} 30 ${Validation.length}` },
            { pattern: notEnglish, message: Validation.persian },
          ]}
          extra={<Space><FaInfoCircle style={{marginTop:8}} /><Typography.Text style={{fontSize:12}}>{Profile.firstNameDescription}</Typography.Text></Space>}
        >
          <Input minLength={3} placeholder={Profile.firstName} />
        </Form.Item>
        <Form.Item
          name="lastName"
          style={{marginBottom:5}}
          rules={[
            { required: true, message: `${Profile.lastName} ${Validation.required}` },
            { min: 3, message: `${Profile.lastName} ${Validation.min} 3 ${Validation.length}` },
            { max: 30, message: `${Profile.lastName} ${Validation.max} 30 ${Validation.length}` },
            { pattern: notEnglish, message: Validation.persian },
          ]}
          extra={<Space><FaInfoCircle style={{marginTop:8}} /><Typography.Text style={{fontSize:12}}>{Profile.lastNameDescription}</Typography.Text></Space>}
        >
          <Input minLength={3} placeholder={Profile.lastName} />
        </Form.Item>
          <Form.Item
              name="nationalCode"
              style={{marginBottom:5}}
              rules={[
                  { required: true, message: `${Profile.nationalCode} ${Validation.required}` },
                  { pattern: isNumber, message: `${Profile.nationalCode} ${Validation.pattern}` },
                  { len: 10, message: `${Profile.nationalCode} 10 ${Validation.length}` },
              ]}
              extra={<Space><FaInfoCircle style={{marginTop:8}} /><Typography.Text style={{fontSize:12}}>{Profile.nationalCodeDescription}</Typography.Text></Space>}
          >
              <Input type="tel" maxLength={10} placeholder={Profile.nationalCode} />
          </Form.Item>
        <Form.Item
          name="mobile"
        >
          <Input disabled={true} placeholder={Profile.mobile} />
        </Form.Item>
        <Form.Item shouldUpdate>
          {() => (
            <Button
              type="primary"
              block
              htmlType="submit"
              disabled={!form.getFieldValue('firstName') || !form.getFieldValue('lastName') || !form.getFieldValue('nationalCode') || !!form.getFieldsError().filter(({ errors }) => errors.length).length}
            >
              { Profile.edit }
            </Button>
          )}
        </Form.Item>
      </Form>
    )
}
